import React from 'react'
import clsx from 'clsx'
import { TextalignJustifycenter } from 'iconsax-react'
import { useTheme } from '@mui/material'

import TaskDescriptionPreviewModal from '@SonarCX/components/atoms/TaskDescriptionPreviewModal'

import useStyles from '../styles'

type DescriptionProps = {
  task: LocalTask
}

const Description: React.FC<DescriptionProps> = ({ task }) => {
  const theme = useTheme()

  const [showDescriptionPreview, setShowDescriptionPreview] =
    React.useState(false)
  const [shouldCheckDescriptionClose, setShouldCheckDescriptionClose] =
    React.useState(false)
  const detailsRef = React.useRef()
  const descriptionHovertime = React.useRef(null)
  const descriptionHovertimeOut = React.useRef(null)

  const classes = useStyles()

  const handleHideDescPreview = React.useCallback(() => {
    setShowDescriptionPreview(false)
    setShouldCheckDescriptionClose(false)
  }, [])

  const handleDescriptionMouseEnter = React.useCallback(() => {
    clearTimeout(descriptionHovertimeOut.current)
    setShouldCheckDescriptionClose(false)
    descriptionHovertime.current = setTimeout(
      () => setShowDescriptionPreview(true),
      500
    )
  }, [setShowDescriptionPreview])

  const handleDescriptionMouseLeave = React.useCallback(() => {
    clearTimeout(descriptionHovertime.current)
    descriptionHovertimeOut.current = setTimeout(() => {
      setShouldCheckDescriptionClose(true)
    }, 250)
  }, [descriptionHovertime])

  if (!task.details) {
    return null
  }

  return (
    <>
      <div
        ref={detailsRef}
        className={clsx(
          'task-details-btn',
          classes.detailsIcon,
          classes.hoverableIconContainer
        )}
        onMouseEnter={handleDescriptionMouseEnter}
        onMouseLeave={handleDescriptionMouseLeave}
        onClick={e => {
          e.stopPropagation()
          e.preventDefault()
        }}
      >
        <span className='icon'>
          <TextalignJustifycenter size={theme.size.sm} variant='Outline' />
        </span>
      </div>

      {showDescriptionPreview && (
        <TaskDescriptionPreviewModal
          onClose={handleHideDescPreview}
          parentRef={detailsRef}
          description={task.details}
          shouldCheckClose={shouldCheckDescriptionClose}
        />
      )}
    </>
  )
}

export default Description
